import {
  ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
  ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const orderAssignmentCreateUrlDocumentAction = (params) => async (dispatch) => {
  const { legal_id, order_id, body } = params || {};

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/companies/${legal_id}/linked-up/orders/${order_id}/documents/signed-urls`,
      body,
    );

    const { data, status } = response || {};

    dispatch({
      method: 'post',
      payload: data || {},
      status: status || {},
      type: ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT,
    });

    return data || {};
  } catch (e) {
    dispatch({
      method: 'post',
      payload: e || {},
      type: ASSIGMENTS_ORDER_CREATE_URL_DOCUMENT_ERROR,
    });

    throw e;
  }
};
